<template>
  <div class="max-w-4xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">隐私政策</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">EliteShop 承诺保护您的个人信息安全和隐私，本政策将说明我们如何收集、使用和保护您的信息</p>
    </div>

    <div class="bg-white rounded-lg shadow-elevation-1 p-8 space-y-8">
      <!-- 政策更新时间 -->
      <div class="text-sm text-neutral-500 border-b border-neutral-200 pb-4">
        <p>最后更新时间：2025年1月1日</p>
        <p class="mt-1">生效时间：2025年1月1日</p>
      </div>

      <!-- 引言 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">引言</h2>
        <p class="text-neutral-600 mb-3">
          EliteShop（以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。
          我们依据《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》等法律法规，
          制定本隐私政策，说明我们如何收集、使用、存储、保护您的个人信息。
        </p>
        <p class="text-neutral-600">
          使用我们的服务即表示您同意我们按照本政策收集、使用、存储和保护您的个人信息。
          如果您不同意本政策，请不要使用我们的服务。
        </p>
      </section>

      <!-- 我们收集的信息 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">一、我们收集的信息</h2>
        <h3 class="font-medium text-lg mb-2">1.1 您主动提供的信息</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>注册账号时提供的信息：手机号、邮箱、密码、姓名等</li>
          <li>下单时提供的信息：收货地址、联系电话、身份证号（用于实名认证）等</li>
          <li>客服咨询时提供的信息：问题描述、订单信息、联系方式等</li>
          <li>参与活动时提供的信息：姓名、联系方式、地址等</li>
        </ul>

        <h3 class="font-medium text-lg mb-2">1.2 我们自动收集的信息</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>设备信息：设备型号、操作系统、IP地址、浏览器类型等</li>
          <li>使用行为：浏览记录、搜索记录、点击记录、购买记录等</li>
          <li>位置信息：基于IP地址的大致位置（您可以选择关闭）</li>
          <li>日志信息：访问时间、访问页面、网络状态等</li>
        </ul>

        <h3 class="font-medium text-lg mb-2">1.3 第三方提供的信息</h3>
        <p class="text-neutral-600 mb-3">
          经您授权后，我们可能从第三方获取您的信息，如：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>第三方登录：微信、QQ、微博等平台的昵称、头像等</li>
          <li>支付服务：支付平台提供的支付信息（脱敏处理）</li>
          <li>物流服务：物流公司提供的配送信息</li>
        </ul>
      </section>

      <!-- 信息使用方式 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">二、信息使用方式</h2>
        <p class="text-neutral-600 mb-3">
          我们仅在以下合法目的范围内使用您的个人信息：
        </p>
        <ul class="space-y-3 text-neutral-600 pl-5 list-disc mb-4">
          <li><strong>提供服务</strong>：完成订单交易、配送商品、提供客服支持等</li>
          <li><strong>优化体验</strong>：个性化推荐商品、优化网站功能、提供定制化服务</li>
          <li><strong>安全保障</strong>：识别异常登录、防止欺诈行为、保护账户安全</li>
          <li><strong>合规要求</strong>：遵守法律法规、响应司法机关要求、保护合法权益</li>
          <li><strong>服务改进</strong>：分析用户行为、改进产品功能、提升服务质量</li>
          <li><strong>营销推广</strong>：发送优惠信息、活动通知（您可以选择退订）</li>
        </ul>
        <p class="text-neutral-600">
          我们不会将您的个人信息用于本政策未载明的其他用途，如需变更用途，会提前征得您的同意。
        </p>
      </section>

      <!-- 信息共享与披露 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">三、信息共享与披露</h2>
        <h3 class="font-medium text-lg mb-2">3.1 信息共享</h3>
        <p class="text-neutral-600 mb-3">
          我们不会向任何无关第三方出售、出租您的个人信息，仅在以下情况下共享：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>经您明确授权或同意</li>
          <li>向物流服务商提供必要的配送信息</li>
          <li>向支付服务商提供必要的支付信息</li>
          <li>向监管机构提供必要的合规信息</li>
          <li>企业合并、收购、破产清算时的信息转移</li>
        </ul>

        <h3 class="font-medium text-lg mb-2">3.2 信息披露</h3>
        <p class="text-neutral-600 mb-3">
          我们仅在以下情况下披露您的个人信息：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>遵守法律法规要求</li>
          <li>响应司法机关、监管机构的合法要求</li>
          <li>保护我们的合法权益</li>
          <li>保护用户或公众的人身财产安全</li>
          <li>您自行公开的信息</li>
        </ul>
      </section>

      <!-- 信息存储与保护 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">四、信息存储与保护</h2>
        <h3 class="font-medium text-lg mb-2">4.1 存储期限</h3>
        <p class="text-neutral-600 mb-3">
          我们仅在实现目的所需的最短时间内存储您的个人信息：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>账号信息：账号注销后保留1年（用于安全审计）</li>
          <li>订单信息：交易完成后保留3年（用于售后服务）</li>
          <li>日志信息：保留6个月</li>
          <li>客服记录：保留1年</li>
        </ul>

        <h3 class="font-medium text-lg mb-2">4.2 安全保护</h3>
        <p class="text-neutral-600 mb-3">
          我们采取多种安全措施保护您的信息：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>数据加密：敏感信息传输和存储均采用加密技术</li>
          <li>访问控制：严格的权限管理，仅授权人员可访问信息</li>
          <li>安全审计：定期进行安全审计和漏洞扫描</li>
          <li>应急响应：建立数据安全事件应急预案</li>
          <li>员工培训：定期开展数据安全培训</li>
        </ul>
      </section>

      <!-- 您的权利 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">五、您的权利</h2>
        <p class="text-neutral-600 mb-3">
          根据相关法律法规，您对您的个人信息享有以下权利：
        </p>
        <ul class="space-y-3 text-neutral-600 pl-5 list-disc mb-4">
          <li><strong>访问权</strong>：您可以查看我们收集的您的个人信息</li>
          <li><strong>更正权</strong>：您可以更正不准确的个人信息</li>
          <li><strong>删除权</strong>：在特定情况下，您可以要求删除您的个人信息</li>
          <li><strong>撤回同意权</strong>：您可以撤回对信息收集和使用的同意</li>
          <li><strong>注销权</strong>：您可以注销您的账号</li>
          <li><strong>投诉权</strong>：您可以对我们的信息处理行为提出投诉</li>
        </ul>
        <p class="text-neutral-600">
          您可以通过"我的账户-隐私设置"或联系客服行使上述权利。
          我们会在15个工作日内响应您的请求。
        </p>
      </section>

      <!-- 未成年人保护 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">六、未成年人保护</h2>
        <p class="text-neutral-600 mb-3">
          我们非常重视未成年人的隐私保护，不建议18周岁以下的未成年人使用我们的服务。
          如果未成年人使用我们的服务，应在监护人的指导和同意下进行。
        </p>
        <p class="text-neutral-600">
          如果监护人发现未成年人的个人信息被我们收集，可以联系我们要求删除相关信息。
        </p>
      </section>

      <!-- 政策变更 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">七、政策变更</h2>
        <p class="text-neutral-600 mb-3">
          我们可能会根据法律法规变化、业务发展需要更新本隐私政策。
          重大变更我们会通过网站公告、弹窗提示、短信通知等方式告知您。
        </p>
        <p class="text-neutral-600">
          继续使用我们的服务即表示您同意更新后的隐私政策。
        </p>
      </section>

      <!-- 联系我们 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">八、联系我们</h2>
        <p class="text-neutral-600 mb-3">
          如果您对本隐私政策有任何疑问或建议，欢迎通过以下方式联系我们：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>隐私专员邮箱：privacy@eliteshop.com</li>
          <li>客服热线：400-123-4567（9:00-22:00）</li>
          <li>联系地址：北京市朝阳区建国路88号 Elite大厦 18层</li>
          <li>在线客服：<router-link to="/contact-us" class="text-primary hover:underline">点击此处</router-link></li>
        </ul>
        <p class="text-neutral-600 mt-3">
          我们会在15个工作日内回复您的咨询。
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>